"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fillExtraEventOptions = void 0;

var _TimelineConstants = require("crm_universal/timeline/TimelineConstants");

var _ObjectTypes = _interopRequireDefault(require("customer-data-objects/constants/ObjectTypes"));

var _IsUngatedStore = _interopRequireDefault(require("crm_data/gates/IsUngatedStore"));

var fillExtraEventOptions = function fillExtraEventOptions(objectType, eventTypes) {
  var eventTypesToSave = eventTypes.toSet();
  var hasIntegrations = eventTypesToSave.find(function (eventOption) {
    return eventOption.match(/integrations-app.*/);
  });

  if (hasIntegrations) {
    eventTypesToSave = eventTypesToSave.add(_TimelineConstants.INTEGRATION_EVENTS);
  }

  if (!hasIntegrations && eventTypesToSave.has(_TimelineConstants.INTEGRATION_EVENTS)) {
    eventTypesToSave = eventTypesToSave.remove(_TimelineConstants.INTEGRATION_EVENTS);
  }

  if (objectType === _ObjectTypes.default.CONTACT && eventTypesToSave.has(_TimelineConstants.EMAIL_SENDS)) {
    eventTypesToSave = eventTypesToSave.add(_TimelineConstants.EMAIL_UNBOUNCES);

    if (!_IsUngatedStore.default.get('CRM:DisableEmailOptouts')) {
      eventTypesToSave = eventTypesToSave.add(_TimelineConstants.EMAIL_OPTOUTS);
    }
  }

  return eventTypesToSave.toList();
};

exports.fillExtraEventOptions = fillExtraEventOptions;